import request from "@/utils/request";

// 列表(主数据列表)
export function loadSettleUnitListDataApi(data) {
  return request({
    url: "web/settleUnitSetting/listData",
    method: "post",
    data
  });
}
// 导出
export function loadSettleUnitExportDataApi(data) {
  return request({
    url: "web/settleUnitSetting/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateSettleUnitApi(data) {
  return request({
    url: "web/settleUnitSetting/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initSettleUnitApi(data) {
  return request({
    url: "web/settleUnitSetting/init",
    method: "post",
    data
  });
}

// 结算单位列表（复选选择）
export function getSettleUnitListApi(data) {
  return request({
      url: "web/settleUnitSetting/listSelectData",
      method: "post",
      data
  });
}